// src/components/card/AboRecipients.tsx

import { DeleteTwoTone, DynamicFeedTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'

type Props = {
  data: { email: string }[]
  onDelete: (newData: { email: string }[]) => void
  title?: string
}

export const AboRecipients = ({
  data,
  onDelete,
  title = 'Empfänger-Liste',
}: Props) => {
  const theme = useTheme()
  const borderColor = theme.palette.lightgray.dark
  const border = `solid 1px ${borderColor}`

  const onClick = key => onDelete(data.filter((f, index) => index !== key))

  return (
    <Card sx={{ border, borderRadius: '10px' }}>
      <CardHeader avatar={<DynamicFeedTwoTone />} title={title} />

      <Divider />

      <CardContent>
        <List>
          {data.map((recipient, key) => (
            <ListItem key={recipient.email}>
              <ListItemAvatar>
                <Avatar>{key + 1}</Avatar>
              </ListItemAvatar>

              <ListItemText>{recipient.email}</ListItemText>

              <IconButton onClick={() => onClick(key)}>
                <Tooltip placement={'bottom-start'} title={'Löschen'}>
                  <DeleteTwoTone />
                </Tooltip>
              </IconButton>
            </ListItem>
          ))}
        </List>

        {data.length === 0 && <Typography>Liste leer</Typography>}
      </CardContent>
    </Card>
  )
}
